module.exports = __webpack_public_path__ + "assets/images/checkbox.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/checkbox.png
// module id = 1496
// module chunks = 1